import React from 'react';

import styles from '../css/CoveragePPUInfoFee.module.css';

export const ColumnWrapper = ({ children }) => (
  <div className={styles.columnWrapper}>
    {children}
  </div>
);
